<template lang="pug">
  .error-handler(:class="{ show: isOpen }")
    .icon-block
      i.material-icons error
    .error-block
      .error-title {{ errorTitle }}
      .error-detail {{ errorDetail }}
</template>

<script>
import { EventBus } from '@/eventBus.js';
import errorMessages from '@/services/errorMessages.js';

export default {
  created () {
    EventBus.$on('apiError', this.handleApiError);
    EventBus.$on('unauthorized', this.handleUnauthorized);
  },
  data() {
    return {
      errorTitle: null,
      errorDetail: null,
      isOpen: false,
      TIMEOUT: 7000,
    };
  },
  methods: {
    handleApiError({ service, method, status }) {
      const serviceMethod = errorMessages[service][method];
      this.errorTitle = serviceMethod[status] ? serviceMethod[status].title : serviceMethod.title;
      this.errorDetail = serviceMethod[status] ? serviceMethod[status].detail : serviceMethod.detail;
      this.open();
    },
    handleUnauthorized() {
      this.$router.push({ name: 'Authentication' });
    },
    open() {
      this.isOpen = true;
      setTimeout(() => {
        this.isOpen = false;
      }, this.TIMEOUT);
    },
  },
  destroyed () {
    EventBus.$off('apiError', this.handleApiError);
    EventBus.$off('unauthorized', this.handleUnauthorized);
  },
}
</script>

<style lang="scss" scoped>
  .error-handler {
    --error: #AA1B1B;
    visibility: hidden;
    background: white;
    position: fixed;
    z-index: 1;
    bottom: 16px;
    right: 16px;
    min-width: 400px;
    box-shadow: 3px 3px 4px 0px #ACACAC;
    border-right: 3px solid var(--error);
    display: flex;
    align-items: center;
    &.show {
      visibility: visible;
      -webkit-animation: fadein 0.5s, fadeout 0.5s 6.5s;
      animation: fadein 0.5s, fadeout 0.5s 6.5s;
    }
    .icon-block {
      background: var(--error);
      i {
        color: white;
        font-size: 48px;
        padding: 12px;
      }
    }
    .error-block {
      padding: 8px 16px;
      .error-title {
        color: var(--error);
        font-weight: bold;
      }
      .error-detail {
        color: #4C4C4C;
        font-size: 14px;
      }
    }
  }
  @-webkit-keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
  }
  @keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
  }
  @-webkit-keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
  }
  @keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
  }
</style>